/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Nav_LabelInputs */

const en_us2_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const pt_br2_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação principal`)
};

const es_419_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación principal`)
};

const pt_pt2_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação principal`)
};

const fr_fr2_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation principale`)
};

const de_de2_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptnavigation`)
};

const it_it2_shell_nav_label = /** @type {(inputs: Shell_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigazione principale`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Shell_Nav_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_nav_label = /** @type {((inputs?: Shell_Nav_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Nav_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_nav_label(inputs)
	if (locale === "es-419") return es_419_shell_nav_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_nav_label(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_nav_label(inputs)
	if (locale === "de-DE") return de_de2_shell_nav_label(inputs)
	if (locale === "it-IT") return it_it2_shell_nav_label(inputs)
	return en_us2_shell_nav_label(inputs)
});
export { shell_nav_label as "shell.nav_label" }